import type { DataLoaderParams } from '../types/data-loader-params';

type ILoader = KalturaPlayerTypes.ILoader;

const { RequestBuilder } = KalturaPlayer.providers;

export class DataLoader implements ILoader {
  private entryId: string;
  private _requests: any[] = [];
  private _response: any;

  public static get id(): string {
    return 'taxonomy-transcript';
  }

  constructor({ entryId, responseProfileSystemName }: DataLoaderParams) {
    this.entryId = entryId;

    const request = new RequestBuilder(new Map());
    request.service = 'baseEntry';
    request.action = 'list';
    request.params = {
      filter: {
        metadataObjectTypeEqual: 1,
        idIn: entryId
      },
      responseProfile: {
        systemName: responseProfileSystemName
      }
    };

    this.requests.push(request);
  }

  public set requests(requests: any[]) {
    this._requests = requests;
  }

  public get requests(): any[] {
    return this._requests;
  }

  public set response(response: any[]) {
    this._response = response;
  }

  public get response(): any {
    return this._response;
  }

  public isValid(): boolean {
    return Boolean(this.entryId);
  }
}
